const loginTemplateUrl = require("ngtemplate-loader!html-loader!./controllers/login/login.html")
const videosTemplateUrl = require("ngtemplate-loader!html-loader!./controllers/videos/videos.html")

routing.$inject = ["$urlRouterProvider", "$locationProvider", "$stateProvider"]
export default function routing($urlRouterProvider, $locationProvider, $stateProvider) {
  // Use a bang as a prefix for the hash in the URL
  $locationProvider.hashPrefix("!")

  // When no state is matched (initial), go to "home"
  $urlRouterProvider.otherwise(function($injector) {
    $injector.get("$state").go("app.home")
  })

  // Define the routing states for the application
  const states = [
    {
      name: "login",
      url: "/login",
      templateUrl: loginTemplateUrl,
      controller: "loginController",
      controllerAs: "$ctrl"
    },
    {
      name: "videos",
      url: "/videos/:slug",
      templateUrl: videosTemplateUrl,
      controller: "videosController",
      controllerAs: "$ctrl"
    },
    {
      name: "app",
      url: "",
      template: "<layout></layout>"
    },
    {
      name: "app.estudiantes",
      url: "/estudiantes/",
      template: "<lista-alumnos></lista-alumnos>"
    },
    {
      name: "app.usuario",
      url: "/usuario/",
      template: "<usuario></usuario>",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.admin",
      url: "/admin/",
      template: "<admin></admin>",
      data: {
        permissions: {
          only: ["mantenedorUsuarios"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.ayuda",
      url: "/ayuda/",
      template: "<ayuda></ayuda>",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.reportes",
      url: "/reportes/",
      template: "<div>reportes</div>",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.atenciones",
      url: "/atenciones/",
      template: "<lista-atenciones></lista-atenciones>",
      data: {
        permissions: {
          only: ["mantenedorAtenciones"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.home",
      url: "/home",
      component: "dashboard",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile",
      url: "/estudiantes/{studentId}",
      component: "satdStudentProfile",
      redirectTo: "app.profile.home",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.home",
      url: "/",
      component: "wrapStudentProfileHome",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.info",
      url: "/info",
      component: "wrapStudentProfileExtraInfo",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.alerts",
      url: "/alerts",
      component: "wrapStudentProfileAlerts",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.alert",
      url: "/alerts/{alertId}",
      component: "wrapStudentProfileAlert",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.finish_alert",
      url: "/alerts/{alertId}/finish",
      component: "wrapStudentProfileFinishAlert",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.raise_alert",
      url: "/raise_alert",
      component: "wrapStudentProfileRaiseAlert",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.alert_raised",
      url: "/alert_raised",
      component: "wrapStudentProfileAlertRaised",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.attentions",
      url: "/attentions",
      component: "wrapStudentProfileAttentions",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.attention",
      url: "/attentions/{attentionId}",
      component: "wrapStudentProfileAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.attentions_by_type",
      url: "/attentions/by_type/{attentionActionId}",
      component: "wrapStudentProfileAttentionsByType",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.add_attention",
      url: "/add_attention",
      component: "wrapStudentProfileAddAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.new_attention",
      url: "/new_attention",
      component: "wrapStudentProfileNewAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.new_past_attention",
      url: "/new_past_attention",
      component: "wrapStudentProfileNewPastAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.attention_created",
      url: "/attention_created",
      component: "wrapStudentProfileAttentionCreated",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.finish_attention",
      url: "/attentions/{attentionId}/finish",
      component: "wrapStudentProfileFinishAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.delete_attention",
      url: "/attentions/{attentionId}/delete",
      component: "wrapStudentProfileDeleteAttention",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.attention_finished",
      url: "/attention_finished",
      component: "wrapStudentProfileAttentionFinished",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.change_situation",
      url: "/change_situation",
      component: "wrapStudentChangeSituation",
      data: {
        permissions: {
          only: ["app_edit_enrollment_state"],
          redirectTo: "app.profile.home"
        }
      }
    },
    {
      name: "app.profile.grades",
      url: "/grades",
      component: "wrapStudentProfileGrades",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    },
    {
      name: "app.profile.comments",
      url: "/comments",
      component: "wrapStudentProfileComments",
      data: {
        permissions: {
          except: ["editarSoloAtencionesMasivas"],
          redirectTo: "app"
        }
      }
    }
  ]

  // Loop over the state definitions and register them
  states.forEach(state => $stateProvider.state(state))
}
